





































































































// Base Components & Types
import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import { Card, Input, Form, FormItem, RemoteSelect, Button, Option, Select } from 'element-ui';
import { ProductInput, ProductFields, PlaceFields, RemoteDirectUploadLinkInput } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import countries from '@/mixins/countryOptions';
import productService from '@/services/ProductService';
// Constants
import currencyOptions from '@/constants/currencyOptions';
import { categoriesOptions } from '@/constants/productCategories';

// Vue components
import FileUploadPreview from '@/components/FileUploadPreview.vue';
import ModalCard from '@/components/layout/ModalCard.vue';

@Component({
  components: {
    'el-card': Card,
    'el-form': Form,
    'el-input': Input,
    'el-form-item': FormItem,
    'el-select': Select,
    'el-button': Button,
    'el-option': Option,
    'modal-card': ModalCard,
    'file-list': FileUploadPreview
  }
})

export default class ProductUpsert extends Mixins(countries) {
  @Prop({ type: Boolean }) open: boolean;
  @Prop({ type: String }) customerOrganizationId: string;
  @Prop({ required: false, type: Object }) product: ProductInput;
  private currencyOptions: SelectOption<string>[] = currencyOptions();
  private categoriesOptions = categoriesOptions();
  private isSubmitting = false;
  private newAttachments: RemoteDirectUploadLinkInput[] = [];
  private deleteAttachments: string[] = [];
  private productInput: ProductInput = { attachments: [] };

  $refs!: {
    productUpsertForm: HTMLFormElement;
  };

  closeModal() {
    this.$refs.productUpsertForm.resetFields();

    this.$emit('cancel');
  }

  private addAttachments(attachments: RemoteDirectUploadLinkInput[]): void {
    this.newAttachments = attachments;
  }

  private removeAttachments(attachments: string[]): void {
    this.deleteAttachments = attachments;
  }

  private async submit(): Promise<void> {
    if (this.isSubmitting) { return; };

    const submission = {
      ...this.product,
      customerOrganizationId: this.customerOrganizationId,
      attachments: this.newAttachments,
      deletedAttachmentIds: this.deleteAttachments,
      currency: this.productInput.currency,
      length: parseFloat((this.product.length || '').toString()),
      width: parseFloat((this.product.width || '').toString()),
      height: parseFloat((this.product.height || '').toString()),
      weight: parseFloat((this.product.weight || '').toString()),
      price: parseFloat((this.product.price || '').toString())
    };

    try {
      this.isSubmitting = true;
      if (this.product.id) {
        const response = await productService.updateProduct(submission);
      } else {
        const response = await productService.createProduct(submission);
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.$refs.productUpsertForm.resetFields();
      this.isSubmitting = false;
      this.$emit('submit');
    }
  }
}
